import Investor from "@/views/Investor.vue";
import TopInvestor from "@/views/Investor/Top.vue";
import InvestorComparator from "@/views/Investor/Comparator.vue";
import InvestorDaysComparator from "@/views/Investor/DaysComparator.vue";
import InvestorSummary from "@/views/Investor/Summary.vue";
import InvestorCreativity from "@/views/Investor/Creativity.vue";
import InvestorCreativityHome from "@/views/Investor/Creativity/Creativity.vue";
import InvestorCreativityDetail from "@/views/Investor/Creativity/CreativityDetail.vue";
import {
  FEATURE_INVESTORS,
  FEATURE_COMPARISON,
  FEATURE_TIME_SLOTS,
  FEATURE_CREATIVITY,
} from "@/constants";

const routes = [
  {
    path: "/investor",
    component: Investor,
    children: [
      {
        path: "top",
        component: TopInvestor,
        name: "TopInvestors",
        meta: {
          allowAgencies: true,
          feature: FEATURE_INVESTORS,
        },
      },
      {
        path: "comparator",
        component: InvestorComparator,
        name: "InvestorComparator",
        meta: {
          feature: FEATURE_COMPARISON,
        },
      },
      {
        path: "days-comparator",
        component: InvestorDaysComparator,
        name: "InvestorDaysComparator",
        meta: {
          feature: FEATURE_TIME_SLOTS,
        },
      },
      {
        path: "creativity",
        component: InvestorCreativity,
        meta: {
          feature: FEATURE_CREATIVITY,
        },
        children: [
          {
            path: "",
            component: InvestorCreativityHome,
            name: "InvestorCreativity",
            meta: {
              feature: FEATURE_CREATIVITY,
            },
          },
          {
            path: ":product_id/:ids",
            component: InvestorCreativityDetail,
            name: "InvestorCreativityDetail",
            meta: {
              feature: FEATURE_CREATIVITY,
            },
          },
        ],
      },
      {
        path: ":type/:id",
        component: InvestorSummary,
        name: "InvestorSummary",
        meta: {
          feature: FEATURE_INVESTORS,
          allow: "agency",
        },
      },
    ],
  },
];

export default routes;
